import { env } from './env';

/**
 * Tracing for the asset pipeline (parse → load → fallback → render).
 *
 * On automatically in dev. In staging/production enable it from the console with
 * `localStorage.debugAssets = '1'` and reload — the asset failures we care about only
 * reproduce against real S3 data, so this needs to be switchable outside dev builds.
 */
function enabled() {
  try {
    return env.DEV || localStorage.getItem('debugAssets') === '1';
  } catch {
    // Safari private mode throws on localStorage access.
    return env.DEV;
  }
}

export function assetLog(stage: string, ...args: any[]) {
  if (enabled()) console.log(`%c[asset:${stage}]`, 'color:#5A46EA;font-weight:bold', ...args);
}

export function assetWarn(stage: string, ...args: any[]) {
  if (enabled()) console.warn(`[asset:${stage}]`, ...args);
}
